<template>
  <div>
    <v-tabs v-model="tab" grow>
      <v-tab key="General">
        Общие
      </v-tab>
      <v-tab key="Regions">
        Области
      </v-tab>
      <v-tab key="Areas">
        Районы
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item key="General">
        <v-container fluid>
          <v-row>
            <v-col cols="12" md="6">
              <v-card>
                <v-card-text>
                  <v-text-field v-model="accountForm.username"
                                label="Логин"/>

                  <v-text-field v-model="accountForm.name"
                                label="ФИО"
                                :error-messages="nameError"
                                :counter="500"
                  />

                  <v-text-field v-model="accountForm.password"
                                type="password"
                                label="Пароль"
                                :error-messages="passwordErrorMessages"
                  />

                  <v-select v-model="accountForm.type"
                            :items="getTypeOptions"
                            :item-text="item => item.name"
                            :item-value="item => item"
                            label="Тип пользователя"
                            dense
                            :error-messages="typeErrorMessages"
                  />

                  <v-text-field v-model="accountForm.postIndex" v-if="isSelectedLoginPostIndexEditable"
                                label="Код постового отделения"
                                :maxlength="6"
                                :counter="6"
                                :error-messages="selectedLoginPostIndexErrors"
                  />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="6">
              <v-card>
                <v-card-text>
                  <v-checkbox
                    v-model="selectAllPermissions"
                    @change="selectAllPermissionsChanged"
                    label="Выбрать все" dense
                    :hide-details="true">
                  </v-checkbox>
                  <br><hr><br>
                  <v-checkbox
                    v-for="item in accountForm.allowedPermissions"
                    v-model="item.allowed"
                    :label="item.permission.name"
                    :key="item.permission.id"
                    flat
                    dense
                    class="mt-1 pa-1"
                    :hide-details="true">
                  </v-checkbox>
                </v-card-text>
              </v-card>

            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <v-tab-item key="Regions">
        <v-card>
          <v-card-text>
            <v-col cols="12" md="4" lg="3" class="pa-0">
                <v-checkbox
                  v-model="selectAllRegions"
                  @change="selectAllRegionsChanged"
                  label="Выбрать все"
                  dense
                  :hide-details="true"
                ></v-checkbox>
              </v-col>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4" lg="3" class="pa-0" v-for="item in accountForm.allowedRegions" :key="item.region.id">
                <v-checkbox
                  v-model="item.allowed"
                  :label="item.region.name"
                  :key="item.region.id"
                  flat
                  dense
                  class="mt-1 pa-1"
                  :hide-details="true"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item key="Areas"
      >
        <v-card>
          <v-card-text>
            <v-col cols="12" md="4" lg="3" class="pa-0">
                <v-checkbox
                  v-model="selectAllAreas"
                  @change="selectAllAreasChanged"
                  label="Выбрать все"
                  dense
                  :hide-details="true"
                ></v-checkbox>
            </v-col>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-text>
            <v-row>
              <v-col v-for="item in accountForm.allowedAreas" cols="12" md="4" lg="3" :key="item.area.id" class="pa-0">
                <v-checkbox
                  v-model="item.allowed"
                  :label="item.area.name"
                  flat
                  dense
                  class="mt-1 pa-1"
                  :hide-details="true"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>

    <v-divider/>

    <v-card flat>
      <v-card-actions>
        <v-btn @click="onCancelClicked" color="secondary" text>Отмена</v-btn>
        <v-spacer/>
        <v-btn color="primary" @click="onCreateAccountClicked">Добавить</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import {Admin, PostOfficeAreaOperator, PostOfficeRegionAdmin, PostOfficeOperator} from "@/enums/account.type";
import {maxLength, minLength, numeric, required, requiredIf} from "vuelidate/lib/validators";
import _ from "underscore";
import AccountService from "@/services/account.service"
import {APP_ACCOUNT_CREATED} from "@/store/modules/app/actions";
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";

export default {
  name: "CreateAccount",
  data() {
    return {
      accountForm: {
        username: "",
        name: "",
        password: "",

        allowedRegions: [],
        allowedAreas: [],
        allowedPermissions: [],

        type: null,
        postIndex: ""
      },

      tab: null,
      typeOptions: [Admin, PostOfficeRegionAdmin, PostOfficeAreaOperator, PostOfficeOperator],
      selectAllPermissions: false,
      selectAllRegions: false,
      selectAllAreas: false
    }
  },
  validations: {
    accountForm: {
      password: {
        required
      },
      name: {
        required,
        maxLength: maxLength(500)
      },
      type: {
        required: required
      },
      postIndex: {
        required: requiredIf(model => {
          return model.type === PostOfficeOperator
        }),
        minLength: minLength(6),
        maxLength: maxLength(6),
        format: numeric
      }
    }
  },
  computed: {
    getTypeOptions(){
      const typeOptionsMap = {
        100: this.typeOptions,
        1: this.typeOptions,
        4: [PostOfficeRegionAdmin, PostOfficeAreaOperator, PostOfficeOperator],
        0: [PostOfficeAreaOperator, PostOfficeOperator],
        3: [PostOfficeOperator],
      };

      const userType = this.$store.getters.appLogin.type.id;
      return typeOptionsMap[userType] || [];
    },
    isSelectedLoginPostIndexEditable() {
      return this.accountForm.type === PostOfficeOperator
    },
    selectedLoginPostIndexErrors() {
      const errors = []

      if (this.$v.accountForm.$dirty) {
        if (!this.$v.accountForm.postIndex.required) {
          errors.push("Введите пост-индекс отделения")
        } else {
          !this.$v.accountForm.postIndex.minLength && errors.push("Введите номер почтового отделения польность - 6 цифр")
          !this.$v.accountForm.postIndex.maxLength && errors.push("Слишком длинный номер почтового отделения")
          !this.$v.accountForm.postIndex.format && errors.push("Номер почтового отделения должен состоять из 6 цифр")
        }
      }

      return errors
    },
    nameError() {
      const errors = []

      if (this.$v.accountForm.name.$dirty) {
        if (!this.$v.accountForm.name.required) {
          errors.push("Введите ФИО")
        } else {
          !this.$v.accountForm.name.maxLength && errors.push(`Слишком длинное`)
        }
      }

      return errors
    },
    passwordErrorMessages() {
      const errors = []

      if (this.$v.accountForm.password.$dirty)
        !this.$v.accountForm.password.required && errors.push("Введите новый пароль")

      return errors
    },
    typeErrorMessages() {
      const errors = []

      if (this.$v.accountForm.type.$dirty)
        !this.$v.accountForm.type.required && errors.push("Выберите тип пользователя")

      return errors
    }
  },
  methods: {
    clear() {
      this.accountForm.allowedRegions = _.map(this.$store.getters.appLogin.regions, region => {
        return {
          region: region,
          allowed: false
        }
      })
      this.accountForm.allowedAreas = _.map(this.$store.getters.appLogin.areas, area => {
        return {
          area: area,
          allowed: false
        }
      })
      this.accountForm.allowedPermissions = _.map(this.$store.getters.appLogin.permissions, permission => {
        return {
          permission: permission,
          allowed: false
        }
      })

      this.accountForm.username = ""
      this.accountForm.name = ""
      this.accountForm.password = ""
      this.accountForm.type = null
      this.accountForm.postIndex = ""

      this.$v.accountForm.$reset()
    },

    selectAllPermissionsChanged() {
      const selected = this.selectAllPermissions;
      for (let i = 0; i < this.accountForm.allowedPermissions.length; i++) {
        this.accountForm.allowedPermissions[i].allowed = selected;
      }
    },

    selectAllRegionsChanged() {
      const selected = this.selectAllRegions;
      for (let i = 0; i < this.accountForm.allowedRegions.length; i++) {
        this.accountForm.allowedRegions[i].allowed = selected;
      }
    },

    selectAllAreasChanged() {
      const selected = this.selectAllAreas;
      for (let i = 0; i < this.accountForm.allowedAreas.length; i++) {
        this.accountForm.allowedAreas[i].allowed = selected;
      }
    },

    onCreateAccountClicked() {
      this.$v.accountForm.$touch()

      if (!this.$v.accountForm.$invalid) {
        this.$store.dispatch(LAYOUT_LOADING_START)

        const checkedPermissions = _.filter(this.accountForm.allowedPermissions, ap => {
          return ap.allowed
        })
        const checkedRegions = _.filter(this.accountForm.allowedRegions, ar => {
          return ar.allowed
        })
        const checkedAreas = _.filter(this.accountForm.allowedAreas, aa => {
          return aa.allowed
        })

        AccountService.createAccount({
          username: this.accountForm.username,
          permissions: _.map(checkedPermissions, ap => {
            return ap.permission
          }),
          region: _.map(checkedRegions, ar => {
            return ar.region
          }),
          areas: _.map(checkedAreas, aa => {
            return aa.area
          }),
          accountType: this.accountForm.type,
          postIndex: this.accountForm.postIndex,
          name: this.accountForm.name,
          password: this.accountForm.password
        })
            .then(() => {
              this.$store.dispatch(APP_ACCOUNT_CREATED)
            }, () => {
              this.$store.dispatch(APP_ACCOUNT_CREATED)
            })
            .finally(() => {
              this.$store.dispatch(LAYOUT_LOADING_STOP)
            })
      }
    },
    onCancelClicked() {
      this.clear()
      this.$emit("cancel")
    }
  },
  created() {
    this.clear()
  }
}
</script>

<style scoped>

</style>
